module.exports = __webpack_public_path__ + "img/potion1.76802d43.png";